import { readonly, ref, watch } from 'vue'
import { useDeviceSettings } from '@/composables/settings'

const showFlyingCoins = ref(false)

const animateCoins = ref(false)

export const useAnimateCoins = () => {

  function doAnimateCoins(delay = 1500) {
    animateCoins.value = true
    setTimeout(() => animateCoins.value = false, delay)
  }

  return {
    animateCoins,
    doAnimateCoins,
  }
}

export const useFlyingCoins = () => {
  const { gameDeviceSettings } = useDeviceSettings()

  function startCoinAnimation(delay = 0) {
    if (gameDeviceSettings.value.coinAnimation) {
      setTimeout(() => showFlyingCoins.value = true, delay)
    }
  }

  watch(showFlyingCoins, () => {
    if (!showFlyingCoins.value) return
    setTimeout(() => showFlyingCoins.value = false, 1500)
  })

  return {
    showFlyingCoins: readonly(showFlyingCoins),
    startCoinAnimation: startCoinAnimation,
  }
}
